import { render } from "./MainTabs.vue?vue&type=template&id=6cdf8237"
import script from "./MainTabs.vue?vue&type=script&lang=js"
export * from "./MainTabs.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zonk/dev/projects/scoretrack-ionic-v7/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__